import { get, keys, omitBy, pullAll, isNil } from 'lodash';

export const isServer = () => get(process, 'release.name');

export const entriesToString = (entries) => {
  const entriesString = Object.entries(entries)
    .map(([key, value]) => {
      if (value) {
        return key;
      }
    })
    .filter((entry) => !!entry)
    .join(' ');
  return entriesString || null;
};

export const isOverlapped = (element) => {
  return element.scrollHeight > element.clientHeight;
};

export const isOuterClick = (element, container) => {
  let target = element;
  while (target){
    if (target === container) {
      return false;
    }
    target = target.parentNode;
  }
  return true;
};

export const isValidFilters = (params, allowedParams) => {
  let selectedParams = keys(omitBy(params, (value) => isNil(value)));
  selectedParams = pullAll(selectedParams, allowedParams);
  return (selectedParams.length !== 0) ? false : true;
};
